import {css} from 'lit';
export const styles = css`:host {
  position: relative;
  display: block;
  height: 100%;
}

a {
  display: flex;
  flex-direction: column;
  height: 100%;
  color: var(--dark-text);
  border: 4px solid #fff;
  border-radius: 4px;
  background-color: #fff;
  font-size: 12px;
}

@media (hover: hover) {
  a:hover {
    background-color: var(--gray-200);
    color: var(--dark-text);
  }
}

a:active {
  background-color: var(--gray-400);
}

@media (min-width: 768px) {
  a {
    font-size: 14px;
  }
}

header {
  position: relative;
}

header picture {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  overflow: hidden;
}

header img {
  display: block;
  width: 100%;
}

header .picture-placeholder {
  background-color: var(--gray-200);
  padding-top: calc(100% / 7 * 3); /* TODO: check this */
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

header ef-avatar {
  position: absolute;
  bottom: 8px;
  left: 8px;
  border: 2px solid #fff;
}

main {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  padding: 4px 8px;
  border-top: 4px solid #fff;
}

.title {
  /* stylelint-disable-next-line value-no-vendor-prefix */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.2;
  flex: 1 1 auto;
  font-size: 1.3em;
  font-weight: 600;
}

.info {
  display: flex;
  margin-top: 4px;
  color: var(--dark-text-secondary);
}

.info > * + * {
  margin-left: 8px;
}

slot[name='menu'] {
  display: block;
  position: absolute;
  top: 16px;
  right: 16px;
}

ef-icon-block {
  --font-size-primary: 14px;
}
`;
export default styles;
